import { useLogger } from '@amzn/event-engine-js-utils';
import React, { useEffect } from 'react';
import { Redirect, useLocation, useParams } from 'react-router-dom';

import { RouteParams, routes } from '../../constants/routes';
import EmbeddedBuild from './../EmbeddedBuild';

const QuickLink = () => {
    const location = useLocation();
    const { quickLinkId } = useParams<RouteParams>();
    const [logger] = useLogger('QuickLink');

    useEffect(() => {
        if (quickLinkId) {
            logger.info(
                `Attempting to load workshop by ${quickLinkId} quicklink.`
            );
        }
    }, [quickLinkId]);

    // If a user attempts to navigate to an embedded or workshop route and enters a route
    // that has an invalid UUID, it will fallback to this component. This is not a valid
    // quicklink URL, so redirect to not found.
    if (
        [routes.embeddedWorkshops, routes.workshops].some((path) =>
            location.pathname.startsWith(path)
        )
    ) {
        return <Redirect to={routes.notFound} />;
    }

    return <EmbeddedBuild />;
};

export default QuickLink;
